import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import { formatNull, formatDate, formatOverflow, formatCaseStatus } from '../../Utils/GlobalUtils';

import NumberOfAppointments from './Components/NumberOfAppointments';

import Loading from '../Loading';
import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel';

import IconContainer from '../IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const UsersCases = ({ userId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [cases, setCases] = React.useState([]);
  const [limitForView, setLimitForView] = React.useState(50);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
      const token = localStorage.getItem('token');

      setLoading(true);

      axios.get(`/api/get-am-cases?user_id=${userId}&limitForView=${limitForView}`, {
          headers: {
              Authorization: `Bearer ${token}`,
          }
      }).then((response) => {
          setWarning('');
          setCases(response.data);
      })
      .catch((error) => {
          console.error(error);
          setWarning(error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее');
      })
      .finally(() => {
          setReload(false);
          setLoading(false);
      });
  }, [reload, userId]);

  const [reloadBoxes, setReloadBoxed] = React.useState(true);


  return (
    <>
      <div className='horizontalContainer'>
        <NumberOfAppointments userId={userId} reloadBoxes={reloadBoxes} />
      </div>

      <div style={{height: '20px'}}></div>

      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
            <div>
              <h3>Картотека управляющего</h3>
            </div>
            <a className='lastUpdateWrapper'>
                {loading ? 
                    <Loading type='inline' /> 
                : 
                    <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                }
            </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr' }}>
              <div>Номер</div>
              <div>Процедура / Должник</div>
              <div>Арбитражный суд</div>
              <div>Дата утверждения управляющего АС</div>
              <div>Начальная дата / Крайняя дата следующего отчета</div>
              <div>Статус</div>
          </div>
        </div>
        {(cases.length==0 && loading) ? <LoadingLines />
        : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
        : cases.length === 0 ? <WarningPanel text='Нет данных для отображения' inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
        : cases.map((caseItem) => (
            <div 
              className='tableRow' 
              style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr' }}
              key={caseItem.id} 
              onClick={() => {navigate(`/case/${caseItem.id}`, { state: { from: location.pathname + location.search + location.hash }})}}
            >
              <div>
                {formatNull(caseItem.number)}
                <p className='description'>{formatNull(caseItem.internal_number)}</p>
              </div>
              <div>
                {formatNull(caseItem.procedure_name)}
                <span className='horizontalLine'></span>
                {caseItem.debtors ?
                    <p>
                        {formatOverflow(caseItem.debtors.map((e) => e.name).join(', '))}
                    </p>
                    :
                    formatNull(caseItem.debtors)
                }
              </div>
              <div>
                {formatNull(caseItem.court_name)}
              </div>
              <div>
                <p>{formatDate(caseItem.date_appointment_m)}</p>
                <p className='description'>(полная версия)</p>
                <p>{formatDate(caseItem.date_appointment_r)}</p>
                <p className='description'>(рез. часть)</p>
              </div>
              <div>{formatDate(caseItem.date_start)} / {formatDate(caseItem.date_next_meeting_creditors)}</div>
              <div>
                {formatCaseStatus(caseItem.status)}
              </div>
            </div>
        ))}
        {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
            <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                <div></div>
                <div>
                    <button
                        type='button'
                        className='button'
                        style={{ width: 'fit-content' }}
                        onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                        disabled={loading}
                    >
                        {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                    </button>
                </div>
                <div></div>
            </div>
        )}
      </div>
    </>
  )
}

export default UsersCases;